import { articleUrls } from "@clockwise/client-commons/src/constants/help-center";
import { Link } from "@clockwise/design-system";
import { PaywallBannerUpgradeCta } from "@clockwise/web-commons/src/ui/paywall-banner-upgrade-cta";
import React from "react";
import { useMonetization } from "../../hooks/useMonetization";

const FlexibleMeetingsGuidance = () => {
  const { canUserAccessFlexMeetings, shouldUserSeeJoinExistingPlan } = useMonetization();

  return (
    <div className="cw-body-base">
      <span className="cw-p-4 cw-flex cw-border-solid cw-rounded-lg cw-border cw-border-subtle">
        <div className="cw-body-base">
          <span className="cw-font-semibold">How does it work?</span>
          <div>
            When you mark meetings flexible, Clockwise will automatically move them to give you
            blocks of Focus Time and resolve conflicts.
          </div>
          <Link href={articleUrls.autopilot} target="_blank" rel="noreferrer">
            Learn More
          </Link>
        </div>
      </span>

      {!canUserAccessFlexMeetings && (
        <PaywallBannerUpgradeCta
          showJoinExistingPlan={shouldUserSeeJoinExistingPlan}
          bannerType="FlexMeetingPage"
        />
      )}
    </div>
  );
};

export default FlexibleMeetingsGuidance;
